export function reversePlans(options) {
  if (!options) return

  options.membership.plans.reverse()
  options.no_membership.plans.reverse()

  return options
}
